import { render, staticRenderFns } from "./dashboard.view.vue?vue&type=template&id=40db8512&scoped=true&"
import script from "./dashboard.view.vue?vue&type=script&lang=js&"
export * from "./dashboard.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db8512",
  null
  
)

export default component.exports